let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kA05C")).then(() => parcelRequire('kqHCt'));